import React, { useState } from "react";
import locations from "../../../data/locations";
import taxInfo from "../../../data/taxInfo";

import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../../firebase";
import { doc, setDoc, collection } from "firebase/firestore";

/* =======================
   DOĞRULAMALAR
   ======================= */

// Vergi Kimlik No (10 hane)
// function isValidTaxNumber(vkno) {
//   if (!/^\d{10}$/.test(vkno)) return false;

//   const digits = vkno.split("").map(Number);
//   const weights = [512, 256, 128, 64, 32, 16, 8, 4, 2];

//   let sum = 0;
//   for (let i = 0; i < 9; i++) {
//     let v = (digits[i] + (9 - i)) % 10;
//     let r = (v * weights[i]) % 9;
//     if (v !== 0 && r === 0) r = 9;
//     sum += r;
//   }

//   const check = sum % 10 === 0 ? 0 : 10 - (sum % 10);
//   return check === digits[9];
// }

// TC Kimlik No (11 hane)
// function isValidTCID(value) {
//   if (!/^\d{11}$/.test(value)) return false;
//   if (value[0] === "0") return false;

//   const d = value.split("").map(Number);

//   const rule10 =
//     ((7 * (d[0] + d[2] + d[4] + d[6] + d[8]) -
//       (d[1] + d[3] + d[5] + d[7])) %
//       10) === d[9];

//   const rule11 =
//     d.slice(0, 10).reduce((a, b) => a + b, 0) % 10 === d[10];

//   return rule10 && rule11;
// }

export default function CorporateSignupDesign() {
//   const [showPassword, setShowPassword] = useState(false);

//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     password: "",
//     phone: "",
//     city: "",
//     district: "",
//     neighborhood: "",
//     companyType: "sahis",
//     taxCity: "",
//     taxOffice: "",
//     taxId: "",
//     companyTitle: "",
//     tcId: "",
//     acceptedTerms: false,
//     acceptedKvkk: false,
//   });

//   const [errors, setErrors] = useState({
//     taxId: "",
//     tcId: "",
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));

//     if (name === "taxId") {
//       let error = "";
//       if (value.length !== 10) error = "Vergi No 10 haneli olmalı";
//       else if (!isValidTaxNumber(value)) error = "Vergi No geçersiz";
//       setErrors((p) => ({ ...p, taxId: error }));
//     }

//     if (name === "tcId" && formData.companyType === "sahis") {
//       let error = "";
//       if (value.length !== 11) error = "TC No 11 haneli olmalı";
//       else if (!isValidTCID(value)) error = "TC No geçersiz";
//       setErrors((p) => ({ ...p, tcId: error }));
//     }
//   };

//   /* === ADRES === */
//   const cities = Object.keys(locations);
//   const districts = formData.city ? Object.keys(locations[formData.city]) : [];
//   const neighborhoods =
//     formData.city && formData.district
//       ? locations[formData.city][formData.district]
//       : [];

//   /* === VERGİ === */
//   const taxCities = Object.keys(taxInfo);
//   const taxOffices = formData.taxCity ? taxInfo[formData.taxCity] : [];

//   /* =======================
//      SUBMIT
//      ======================= */
//   const handleSubmit = async () => {
//     try {
//       if (!formData.acceptedTerms || !formData.acceptedKvkk) {
//         alert("Sözleşmeleri kabul etmelisiniz");
//         return;
//       }

//       if (formData.password.length < 6) {
//         alert("Şifre en az 6 karakter olmalıdır");
//         return;
//       }

//       const authResult = await createUserWithEmailAndPassword(
//         auth,
//         `${formData.taxId}@company.local`,
//         formData.password
//       );

//       const uid = authResult.user.uid;

//       /* === COMPANY DOCUMENT === */
//       const companyRef = doc(db, "companies", formData.companyTitle);

//       await setDoc(companyRef, {
//         company_id: formData.companyTitle,
//         uid,
//         taxInfo: {
//           taxNumber: Number(formData.taxId),
//           taxCity: formData.taxCity,
//           taxOfficeName: formData.taxOffice,
//           companyType:
//             formData.companyType === "sahis"
//               ? "Şahıs Şirketi"
//               : "Limited/Anonim",
//         },
//         createdAt: new Date(),
//       });

//       /* === AUTHORIZED PERSON === */
//       const personRef = doc(
//         collection(companyRef, "authorized_person"),
//         "personel_info"
//       );

//       await setDoc(personRef, {
//         person_name: formData.fullName,
//         person_email: formData.email,
//         person_phone: formData.phone,
//         city: formData.city,
//         district: formData.district,
//         neighborhood: formData.neighborhood,
//         identificationNo:
//           formData.companyType === "sahis" ? formData.tcId : null,
//         role: "corporate"
//       });

//       /* === SUBSCRIPTION COLLECTION === */
//       const subscriptionRef = doc(
//         collection(companyRef, "subscription"),
//         "subscription_plan"
//       );

//       const startDate = new Date();

//       await setDoc(subscriptionRef, {
//         planId: "free", // üye olurken plan "free" olarak başlıyor
//         projectLimit: "0", // üye olurken hiç proje giremez (abonelik alması gerekir)
//         updatedAt: null, // abone olmadığı için herhangi bir güncelleme söz konusu değil
//         paymentFailed: null, //ilk üye olunduğunda herhangi bir ödeme işlemi gerçekleştirilmediği için boş
//         isActive: true,
//         startDate: startDate,
//         endDate: null, // Boş olarak eklendi (üyelik olmadığı için)
//         autoRenew: null,
//         createdAt: new Date()
//       });

//       alert("Kurumsal kayıt başarıyla tamamlandı ✅");
//     } catch (err) {
//       console.error(err);
//       alert("Kayıt sırasında hata oluştu");
//     }
//   };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Sayfamız güncelleniyor en kısa sürede hizmetinizde olacak</h2>

      {/* <div style={styles.columns}> */}
        {/* KİŞİSEL */}
        {/* <div style={styles.column}>
          <h3>Kişisel Bilgiler</h3>

          <input name="fullName" placeholder="Ad Soyad" onChange={handleChange} style={styles.input} />
          <input name="email" placeholder="E-posta" onChange={handleChange} style={styles.input} */}

{/* ŞİFRE + GÖSTER / GİZLE */}
{/* <div style={{ position: "relative" }}>
  <input
    type={showPassword ? "text" : "password"}
    name="password"
    placeholder="Şifre"
    onChange={handleChange}
    style={{ ...styles.input, paddingRight: 45 }}
  />

  <span
    onClick={() => setShowPassword(!showPassword)}
    style={styles.eye}
  >
    {showPassword ? ( */}

      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.4 21.4 0 0 1 5.06-6.94" />
        <path d="M1 1l22 22" />
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a21.77 21.77 0 0 1-2.34 3.88" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      </svg>
    ) : ( */}

      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    )}
  </span>
</div> */}


          {/* <input name="phone" placeholder="Telefon" onChange={handleChange} style={styles.input} />

          <select value={formData.city} onChange={(e) => setFormData({ ...formData, city: e.target.value, district: "", neighborhood: "" })} style={styles.input}>
            <option value="">İl</option>
            {cities.map((c) => <option key={c}>{c}</option>)}
          </select>

          <select value={formData.district} disabled={!formData.city} onChange={(e) => setFormData({ ...formData, district: e.target.value, neighborhood: "" })} style={styles.input}>
            <option value="">İlçe</option>
            {districts.map((d) => <option key={d}>{d}</option>)}
          </select>

          <select value={formData.neighborhood} disabled={!formData.district} onChange={(e) => setFormData({ ...formData, neighborhood: e.target.value })} style={styles.input}>
            <option value="">Mahalle</option>
            {neighborhoods.map((n) => <option key={n}>{n}</option>)}
          </select>
        </div> */}

        {/* ŞİRKET */}
        {/* <div style={{ ...styles.column, borderLeft: "1px solid #ddd" }}>
          <h3>Şirket Bilgileri</h3>

          <div style={styles.buttonGroup}>
            <button style={formData.companyType === "sahis" ? styles.activeButton : styles.passiveButton} onClick={() => setFormData({ ...formData, companyType: "sahis" })}>
              Şahıs
            </button>
            <button style={formData.companyType === "limited" ? styles.activeButton : styles.passiveButton} onClick={() => setFormData({ ...formData, companyType: "limited", tcId: "" })}>
              Limited / A.Ş.
            </button>
          </div>

          <input name="companyTitle" placeholder="Şirket Ünvanı" onChange={handleChange} style={styles.input} />

          <select value={formData.taxCity} onChange={(e) => setFormData({ ...formData, taxCity: e.target.value, taxOffice: "" })} style={styles.input}>
            <option value="">Vergi Dairesi İli</option>
            {taxCities.map((c) => <option key={c}>{c}</option>)}
          </select>

          <select value={formData.taxOffice} disabled={!formData.taxCity} onChange={(e) => setFormData({ ...formData, taxOffice: e.target.value })} style={styles.input}>
            <option value="">Vergi Dairesi</option>
            {taxOffices.map((o) => <option key={o}>{o}</option>)}
          </select>

          <input name="taxId" placeholder="Vergi Kimlik No" onChange={handleChange} style={styles.input} />
          {errors.taxId && <span style={styles.error}>{errors.taxId}</span>}

          <input name="tcId" placeholder="TC Kimlik No" disabled={formData.companyType === "limited"} onChange={handleChange} style={styles.input} />
          {errors.tcId && <span style={styles.error}>{errors.tcId}</span>}
        </div> */}
      {/* </div> */}

      {/* <div style={styles.contracts}>
        <label><input type="checkbox" name="acceptedTerms" onChange={handleChange} /> Kullanım Sözleşmesi</label>
        <label><input type="checkbox" name="acceptedKvkk" onChange={handleChange} /> KVKK</label>
      </div> */}

      {/* <button style={styles.submitButton} onClick={handleSubmit}>
        Kayıt Ol
      </button> */}
    </div>
  );
}

/* === STYLES === */
const styles = {
  container: { maxWidth: 1100, margin: "40px auto", padding: 30, background: "#f9f9f9", borderRadius: 16 },
  heading: { textAlign: "center", marginBottom: 30, color: "#001E78" },
  columns: { display: "flex", gap: 30 },
  column: { flex: 1, padding: "0 20px", display: "flex", flexDirection: "column", gap: 12 },
  input: { padding: 12, borderRadius: 8, border: "1px solid #ccc" },
  buttonGroup: { display: "flex", gap: 10 },
  activeButton: { flex: 1, padding: 12, background: "#001E78", color: "#fff", borderRadius: 8, border: "none" },
  passiveButton: { flex: 1, padding: 12, background: "#e0e0e0", borderRadius: 8, border: "none" },
  contracts: { marginTop: 25, display: "flex", flexDirection: "column", gap: 10 },
  submitButton: { marginTop: 30, padding: 16, background: "#001E78", color: "#fff", borderRadius: 10, border: "none" },
  error: { color: "red", fontSize: 13 },
  eye: {
    position: "absolute",
    right: 14,
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#555",
  }
};